<template>
  <div class="wrap m-a ov-h" id="wrap">
    <div class="kol-banner influencer-banner banner">
      <div class="w-1200 m-a">
        <div class="banner-content"></div>
      </div>
    </div>

    <div class="how-to-apply">
      <div class="w1000px m-a ov-h">
        <h2>How to Apply</h2>
        <ul>
          <li class="sign-up">
            <div>
              <b>Sign Up</b>
              <span>Complete the application form below.</span>
            </div>
          </li>
          <li class="application">
            <div>
              <b>Application Processing</b>
              <span>We will go through your profile and contact you once your application has been approved.</span>
            </div>
          </li>
          <li class="influencer">
            <div>
              <b>Become Our Influencer</b>
              <span>Become a member of our influencer network, and start sharing your FJDynamics reviews now!</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <a name="join"></a>
    <div class="form-container">
      <div class="w1000px m-a">
        <h2>Become Our Influencer</h2>
        <div class="form-title">Personal Information</div>

        <Form ref="formInline" :model="formInline" :rules="ruleInline" class="information-form">
          <FormItem prop="name">
            <Input v-model="formInline.name" placeholder="Please select">
              <div slot="prepend" class="from-line"><span class="c-f24130ff">*</span> Name</div>
            </Input>
          </FormItem>
          <FormItem prop="phone">
            <Input v-model="formInline.phone" placeholder="Please select">
              <div slot="prepend" class="from-line"><span class="c-f24130ff">*</span> Phone</div>
            </Input>
          </FormItem>
          <FormItem prop="email">
            <Input v-model="formInline.email" placeholder="Please select">
              <div slot="prepend" class="from-line"><span class="c-f24130ff">*</span> Email</div>
            </Input>
          </FormItem>
          <FormItem prop="country">
            <div class="country information-form-item">
              <label for="Country">
                <strong><i class="c-f24130ff">*</i> Country</strong>
                <Select v-model="formInline.country" placeholder="Please select" filterable style="width: 80%">
                  <Option v-for="item in countryList" :value="item.value" :key="item.value">{{ item.value }}</Option>
                </Select>
              </label>
            </div>
          </FormItem>
        </Form>

        <div class="form-title">Your Social Media Channels</div>
        <ul class="social-channels">
          <li class="youtube-mod" :class="isRequired ? 'required' : ''">
            <div class="hd">
              <label for="link1">
                <input
                  type="text"
                  v-model="formInline.youtubeLink"
                  id="link1"
                  class="socal-link"
                  placeholder="Add your link here"
                />
                <i></i>
              </label>
            </div>
            <div class="bd">
              <div class="txt">Number of Followers：</div>
              <Slider v-model="formInline.youtubeNum" :mix="0" :max="1000000"></Slider>
            </div>
          </li>
          <li class="linkin-mod" :class="isRequired ? 'required' : ''">
            <div class="hd">
              <label for="link2">
                <input
                  type="text"
                  v-model="formInline.insLink"
                  id="link2"
                  class="socal-link"
                  placeholder="Add your link here"
                />
                <i></i>
              </label>
            </div>
            <div class="bd">
              <div class="txt">Number of Followers：</div>
              <Slider v-model="formInline.insNum" :mix="0" :max="1000000"></Slider>
            </div>
          </li>
          <li class="facebook-mod" :class="isRequired ? 'required' : ''">
            <div class="hd">
              <label for="link3">
                <input
                  type="text"
                  v-model="formInline.facebookLink"
                  id="link3"
                  class="socal-link"
                  placeholder="Add your link here"
                />
                <i></i>
              </label>
            </div>
            <div class="bd">
              <div class="txt">Number of Followers：</div>
              <Slider v-model="formInline.facebookNum" :mix="0" :max="1000000"></Slider>
            </div>
          </li>
        </ul>

        <ul class="social-channels" style="margin-top: 12px">
          <li class="tiktok-mod" :class="isRequired ? 'required' : ''">
            <div class="hd">
              <label for="link4">
                <input
                  v-model="formInline.tiktokLink"
                  type="text"
                  id="link4"
                  class="socal-link"
                  placeholder="Add your link here"
                />
                <i></i>
              </label>
            </div>
            <div class="bd">
              <div class="txt">Number of Followers：</div>
              <Slider v-model="formInline.tiktokNum" :mix="0" :max="1000000"></Slider>
            </div>
          </li>
          <li class="linkedin-mod" :class="isRequired ? 'required' : ''">
            <div class="hd">
              <label for="link5">
                <input
                  type="text"
                  v-model="formInline.linkedinLink"
                  id="link5"
                  class="socal-link"
                  placeholder="Add your link here"
                />
                <i></i>
              </label>
            </div>
            <div class="bd">
              <div class="txt">Number of Followers：</div>
              <Slider v-model="formInline.linkedinNum" :mix="0" :max="1000000"></Slider>
            </div>
          </li>
          <li class="twitter-mod" :class="isRequired ? 'required' : ''">
            <div class="hd">
              <label for="link6">
                <input
                  type="text"
                  v-model="formInline.twitterLink"
                  id="link6"
                  class="socal-link"
                  placeholder="Add your link here"
                />
                <i></i>
              </label>
            </div>
            <div class="bd">
              <div class="txt">Number of Followers：</div>
              <Slider v-model="formInline.twitterNum" :mix="0" :max="1000000"></Slider>
            </div>
          </li>
        </ul>

        <div class="channel">
          <div class="form-title">What’s Your Channel About</div>
          <Select v-model="formInline.remark" style="width: 1000px; height: 50px" placeholder="Please select">
            <Option v-for="item in channelList" :value="item.value" :key="item.value">{{ item.value }}</Option>
          </Select>
        </div>
        <!-- end: channel -->
        <div class="tips">FJDynamics reserves all the right for the final interpretation.</div>
        <a class="join-btn submint-btn" href="javascript:;" @click="handleSubmit('formInline')">Submit</a>
      </div>
    </div>
    <!-- 成功弹窗 -->
    <Modal
      v-model="showSuccessModal"
      footer-hide
      :styles="{ width: '730px', textAlign: 'center' }"
      class-name="vertical-center-modal"
    >
      <svg-icon class-name="success-icon" icon-class="kol-success"></svg-icon>
      <p class="modal-content">
        Thank you for your interest in joining our Influencer Program. Your application will be reviewed by our team and
        if we think that you're a good fit, we'll be in touch!
      </p>
    </Modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showSuccessModal: false,
        channelList: [
          {
            value: 'Agriculture'
          },
          {
            value: 'Ag Machinery'
          },
          {
            value: 'Construction'
          },
          {
            value: 'Surveying'
          },
          {
            value: 'Gardening'
          },
          {
            value: 'Business'
          },
          {
            value: 'Entertainment'
          },
          {
            value: 'Others'
          }
        ],
        country: '', // 城市
        countryList: [],
        formInline: {
          activityName: 'KOL',
          email: '',
          name: '',
          phone: '',
          country: '',
          province: '',
          youtubeLink: '',
          youtubeNum: 0,
          insLink: '',
          insNum: 0,
          facebookLink: '',
          facebookNum: 0,
          linkedinLink: '',
          linkedinNum: 0,
          tiktokLink: '',
          tiktokNum: 0,
          twitterLink: '',
          twitterNum: 0,
          remark: '',
          languageCode: 'en-US'
        },
        isRequired: false, // youtube 等输入框没填写则报错
        ruleInline: {
          name: [{ required: true, message: 'Please fill in the user name', trigger: 'blur' }],
          phone: [{ required: true, message: 'Please fill in the password.', trigger: 'blur' }],
          email: [
            { required: true, message: 'Please fill in the user name', trigger: 'blur' },
            { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
          ],
          country: [{ required: true, message: 'Please fill in the country', trigger: 'change' }]
        }
      }
    },
    created() {},
    mounted() {
      this.getCountryList()
    },
    methods: {
      async getCountryList() {
        const { data } = await this.$api.retentionApi.getCountry('en')
        console.log(data)
        data.forEach((item) => this.countryList.push({ value: item.nameEn }))
      },
      handleSubmit(name) {
        // 只校验 youtube 等link 是否有值
        const linkMap = ['youtubeLink', 'insLink', 'facebookLink', 'linkedinLink', 'tiktokLink', 'twitterLink']

        this.$refs[name].validate(async (valid) => {
          if (valid) {
            this.isRequired = linkMap.every((item) => this.formInline[item] === '')
            if (this.isRequired) return
            const data = await this.$api.retentionApi.toSubmitForm(this.formInline)
            if (data.status === 200) {
              this.showSuccessModal = true
              this.$refs[name].resetFields()
            }
            // this.$Message.success('Success!')
          } else {
            // this.$Message.error('Fail!')
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  h2,
  h2 a {
    font-weight: 700;
    text-align: center;
    color: #333;
    font-size: 34px;
  }
  .how-to-apply .sign-up:before {
    background-image: url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h120v120H0z'/%3E%3Cpath d='M81.268 37.501a6 6 0 0 1 8.439-.887l15.318 12.404a6 6 0 0 1 .887 8.44L69.663 102.22a6 6 0 0 1-3.315 2.07l-18.975 4.374a3 3 0 0 1-3.674-2.924l.007-19.732a6 6 0 0 1 1.337-3.774zM47.702 97.697l-.003 6.788 6.527-1.505-6.524-5.283zm27.232-46.019L48.152 84.753a2 2 0 0 0-.446 1.258l-.002 6.541 11.469 9.288 6.276-1.446a2 2 0 0 0 .875-.45l.12-.116.11-.125L93.36 66.6l-4.233-3.428-27.276 33.685a2 2 0 0 1-3.207-2.386l.098-.131 27.276-33.686-3.743-3.031-27.276 33.685a2 2 0 0 1-3.207-2.385l.098-.132 27.277-33.685-4.233-3.428zM90 83.699a2 2 0 0 1 1.995 1.851l.005.15v8.233c0 3.837-3.119 6.938-6.986 7.063l-.243.004h-6.627a2 2 0 0 1-.15-3.995l.15-.005h6.627c1.735 0 3.13-1.294 3.224-2.895l.005-.172v-8.234a2 2 0 0 1 2-2zM84.847 12c3.857 0 7.021 2.994 7.149 6.763L92 19v11.09a2 2 0 0 1-3.995.149l-.005-.15V19c0-1.584-1.3-2.903-2.966-2.995L84.847 16H19.153c-1.692 0-3.053 1.262-3.148 2.825L16 19v75c0 1.584 1.3 2.903 2.966 2.995l.187.005H37.35a2 2 0 0 1 .15 3.995l-.15.005H19.153c-3.857 0-7.021-2.994-7.149-6.763L12 94V19c0-3.8 3.086-6.872 6.912-6.996l.24-.004h65.695zM33.172 75.608a2 2 0 0 1 .15 3.994l-.15.006h-8.816a2 2 0 0 1-.15-3.995l.15-.005h8.816zm0-15.115a2 2 0 0 1 .15 3.994l-.15.006h-8.816a2 2 0 0 1-.15-3.995l.15-.005h8.816zm16.69 0a2 2 0 0 1 .149 3.994l-.15.006H41.36a2 2 0 0 1-.15-3.995l.15-.005h8.502zm37.328-20.77a2 2 0 0 0-2.813.295L77.45 48.57l18.427 14.921 6.925-8.551a2 2 0 0 0-.172-2.705l-.124-.108zm-54.018 5.655a2 2 0 0 1 .15 3.995l-.15.005h-8.816a2 2 0 0 1-.15-3.994l.15-.006h8.816zm27.553 0a2 2 0 0 1 .15 3.995l-.15.005H41.36a2 2 0 0 1-.15-3.994l.15-.006h19.365zM33.172 30.264a2 2 0 0 1 .15 3.994l-.15.006h-8.816a2 2 0 0 1-.15-3.995l.15-.005h8.816zm44.085 0a2 2 0 0 1 .15 3.994l-.15.006h-35.74a2 2 0 0 1-.15-3.995l.15-.005h35.74z' fill='%23666' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
  }
  .how-to-apply .application:before {
    background-image: url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h120v120H0z'/%3E%3Cpath d='M86.535 15a7.038 7.038 0 0 1 7.034 6.801l.004.237v8.842a2 2 0 0 1-3.994.15l-.006-.15v-8.842a3.038 3.038 0 0 0-2.86-3.033L86.536 19H21.038a3.038 3.038 0 0 0-3.033 2.86l-.005.178v75.574a3.038 3.038 0 0 0 2.86 3.033l.178.005h25.273a2 2 0 0 1 .15 3.994l-.15.006H21.038a7.038 7.038 0 0 1-7.034-6.801L14 97.612V22.038a7.038 7.038 0 0 1 6.801-7.034l.237-.004h65.497zm-41.25 26.246c13.078-13.078 34.282-13.078 47.36 0 12.452 12.453 13.048 32.272 1.787 45.43l10.682 10.68a2 2 0 0 1-2.701 2.946l-.128-.117-10.629-10.628c-13.137 12.12-33.618 11.803-46.372-.95-13.078-13.079-13.078-34.283 0-47.36zm44.531 2.829c-11.516-11.517-30.187-11.517-41.703 0-11.516 11.516-11.516 30.187 0 41.703 11.516 11.516 30.187 11.516 41.703 0 11.517-11.516 11.517-30.187 0-41.703zm-55.552 44.61a2 2 0 0 1 .149 3.994l-.15.005h-8.816a2 2 0 0 1-.15-3.994l.15-.006h8.817zm56.05-21.16a2 2 0 0 1 1.53 2.378 23.31 23.31 0 0 1-6.324 11.579 23.31 23.31 0 0 1-11.281 6.258 2 2 0 0 1-.898-3.898 19.31 19.31 0 0 0 9.35-5.189 19.31 19.31 0 0 0 5.244-9.597 2 2 0 0 1 2.378-1.531zM62.252 44.49a2 2 0 0 1-1.037 2.631 19.356 19.356 0 0 0-5.978 4.079 19.354 19.354 0 0 0-4.117 6.068 2 2 0 0 1-3.677-1.576 23.353 23.353 0 0 1 4.966-7.32c2.1-2.101 4.541-3.758 7.211-4.919a2 2 0 0 1 2.632 1.037zm-27.99.11a2 2 0 0 1 .15 3.994l-.15.006h-8.816a2 2 0 0 1-.15-3.995l.15-.005h8.817zm0-15.115a2 2 0 0 1 .15 3.994l-.15.006h-8.816a2 2 0 0 1-.15-3.995l.15-.005h8.817z' fill='%23666' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
  }
  .how-to-apply .influencer:before {
    background-image: url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h120v120H0z'/%3E%3Cpath d='M92.833 15a2 2 0 0 1 1.994 1.85l.006.15-.001 43.723 8.61-3.364a2 2 0 0 1 2.722 1.714l.005.149v44.084a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V59.222a2 2 0 0 1 2.728-1.863l8.608 3.364V17a2 2 0 0 1 1.85-1.995l.15-.005h65.497zm9.336 47.15L60.812 78.31a2 2 0 0 1-1.455 0L18 62.15v39.155h84.169V62.15zm-28.66 20.2a2 2 0 0 1 .155 2.699l-.115.129-13.26 13.636a2 2 0 0 1-2.82.048l-.113-.119-7.588-8.598a2 2 0 0 1 2.88-2.771l.12.124 6.158 6.98L70.68 82.388a2 2 0 0 1 2.828-.04zM90.833 19H29.336v43.286l30.748 12.013 30.748-12.014V18.999zm-30.747 6.922c6.007 0 10.877 4.87 10.877 10.877 0 3.276-1.449 6.215-3.74 8.209A19.77 19.77 0 0 1 78.31 55.794a2 2 0 1 1-3.689 1.548 15.758 15.758 0 0 0-14.535-9.666 15.758 15.758 0 0 0-14.526 9.643 2 2 0 1 1-3.686-1.552 19.774 19.774 0 0 1 11.075-10.76 10.85 10.85 0 0 1-3.74-8.208c0-6.007 4.87-10.877 10.877-10.877zm0 4a6.877 6.877 0 1 0 0 13.754 6.877 6.877 0 0 0 0-13.754z' fill='%23666' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
  }
  .join-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    color: #fff;
  }
  .join-btn:after {
    position: absolute;
    content: '';
    top: 50%;
    transform: translateY(-50%);
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='22' viewBox='0 0 24 22' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h24v24H0z'/%3E%3C/defs%3E%3Cg transform='translate(0 -1)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M10.823 1c3.782 0 7.34 2.03 9.288 5.299a.607.607 0 0 1-.205.829.599.599 0 0 1-.824-.208c-1.758-2.951-4.845-4.712-8.26-4.712-5.306 0-9.622 4.346-9.622 9.687 0 5.342 4.316 9.686 9.623 9.686a9.638 9.638 0 0 0 8.371-4.905.597.597 0 0 1 .818-.226.606.606 0 0 1 .225.824c-1.923 3.403-5.53 5.515-9.414 5.515C4.855 22.79 0 17.902 0 11.895 0 5.887 4.855 1 10.823 1zm9.922 9.374c0-.475.615-.714.977-.377l2.11 1.966a.507.507 0 0 1 0 .753l-2.11 1.966c-.362.335-.977.098-.977-.376v-1.39h-8.127c-.341 0-.618-.258-.618-.576 0-.32.277-.576.618-.576h8.127z' fill='%23FFF' mask='url(%23b)'/%3E%3C/g%3E%3C/svg%3E");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
  @media screen and (min-width: 769px) {
    .w1000px {
      width: 1000px;
    }
    .influencer-banner {
      margin-top: 0.76rem;
      height: 360px;
      background: url('@/assets/images/influencer/banner.jpg') no-repeat center;
      background-size: cover;
      overflow: hidden;
    }
    .how-to-apply {
      padding-top: 42px;
      padding-bottom: 56px;
      background-color: #fafafa;
    }
    .how-to-apply h2 {
      margin-bottom: 30px;
    }
    .how-to-apply ul {
      width: 690px;
      margin: 0 auto;
    }
    .how-to-apply li {
      display: flex;
      position: relative;
      padding-top: 40px;
      padding-bottom: 60px;
    }
    .how-to-apply li:before {
      display: block;
      content: '';
      margin: 0 80px 0 40px;
      width: 120px;
      height: 120px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .how-to-apply li b {
      font-size: 24px;
      display: block;
      margin-bottom: 10px;
      margin-top: 10px;
      font-weight: 700;
    }
    .how-to-apply li span {
      color: #767676;
      display: block;
      font-size: 0.28rem;
      width: 4.5rem;
    }
    .how-to-apply li:after {
      position: absolute;
      content: '';
      display: block;
      height: 24px;
      width: 100%;
      bottom: 0;
      background: url("data:image/svg+xml,%3Csvg width='692' height='24' viewBox='0 0 692 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.703 1H312l34 22.482L380 1h311.02' stroke='%23BFBFBF' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E")
        no-repeat center;
      background-size: cover;
    }
    .how-to-apply li:last-child {
      padding-bottom: 20px;
    }
    .how-to-apply li:last-child:after {
      display: none;
    }
    .form-container {
      padding: 1rem 0 1.5rem 0;
      background-color: #f2f2f2;
    }
    .form-title {
      margin: 0.8rem 0.27rem 0.3rem;
      font-size: 0.34rem;
      font-weight: 700;
    }
    .information-form {
      margin: 0 0.27rem 0;
    }
    // .information-form li {
    //   margin-bottom: 0.3rem;
    // }
    .information-form .information-form-item {
      margin-bottom: 0.3rem;
    }
    .information-form label {
      position: relative;
      display: flex;
      height: 0.5rem;
      background-color: #fff;
      border: 1px solid transparent;
    }
    .information-form label strong,
    .information-form label input {
      display: block;
      height: 100%;
      line-height: 1rem;
    }
    .information-form label strong {
      padding: 0 0.3rem;
      width: 20%;
      position: relative;
      font-weight: 700;
      display: inline-block;
      height: 100%;
      line-height: 50px;
      font-weight: 700;
      vertical-align: middle;
      font-size: 18px;
    }
    .information-form label strong i {
      color: red;
    }
    .information-form label strong:after {
      display: block;
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 0.35rem;
      width: 1px;
      background-color: #bfbfbf;
    }
    .information-form label div {
      width: 60%;
      margin-left: 0.2rem;
    }
    .information-form label input {
      width: 99%;
      font-size: 0.28rem;
      font-weight: 700;
    }
    .information-form .required {
      border-color: red;
    }
    .information-form .country .tri-ico {
      position: absolute;
      right: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.2s;
      cursor: pointer;
      display: inline-block;
      width: 0.22rem;
      height: 0.12rem;
      background: url("data:image/svg+xml,%3Csvg width='16' height='9' viewBox='0 0 16 9' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cfilter color-interpolation-filters='auto' id='a'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 0.462325 0 0 0 0 0.462325 0 0 0 0 0.462325 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cpath d='M0 7.459L7.49 0a1.418 1.418 0 0 1 0 2.01L1.01 8.463 0 7.46zm1.016-1.01l6.569 6.538A1.42 1.42 0 0 1 7.584 15L.009 7.452l1.008-1.005-.001.002z' fill='%23515151' fill-rule='nonzero' transform='rotate(-90 4.5 4)' filter='url(%23a)'/%3E%3C/svg%3E")
        no-repeat center;
      background-size: cover;
    }
    .select-list {
      position: relative;
      overflow: hidden;
      display: none;
      width: 100%;
      right: 0;
      background: #fff;
      z-index: 9;
      border-top: 1px solid #ddd;
    }
    .select-list ul {
      width: 100%;
      float: left;
      height: 5.5rem;
      overflow-y: scroll;
      transition: width 0.35s;
    }
    .select-list ul:last-child {
      width: 0;
    }
    .hasStates ul {
      width: 50% !important;
    }
    .select-list li {
      margin: 0 25px;
      padding: 0 10px;
      line-height: 50px;
      width: auto;
      text-align: left;
      cursor: pointer;
      border-bottom: 1px solid #eee;
    }
    .select-list .curr,
    .select-list li:hover {
      color: #ffc550;
    }
    .hasStates ul:first-child .curr:after {
      width: 9px;
      height: 16px;
      content: '';
      float: right;
      position: relative;
      top: 20px;
      background: url('@/assets/images/tri_ico_yellow.png');
    }
    .select-list ul::-webkit-scrollbar {
      width: 5px;
      height: 1px;
    }
    .select-list ul::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #ccc;
    }
    .select-list ul::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    }
    .social-channels {
      display: flex;
      justify-content: space-between;
    }
    .social-channels li {
      width: 326px;
      background-color: #fff;
      border: 1px solid transparent;
    }
    .social-channels li.required {
      border-color: red;
    }
    .social-channels .hd {
      padding: 10px 15px;
      border-bottom: 1px solid #eee;
    }
    .social-channels .hd input {
      display: inline-block;
      width: 160px;
      margin-right: 5px;
      margin-left: 10px;
      vertical-align: middle;
      background-color: transparent;
    }
    .social-channels .hd i {
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
      width: 16px;
      height: 16px;
      background: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.386 1v1H3.5a1.5 1.5 0 0 0-1.498 1.412L2 3.5v9a1.5 1.5 0 0 0 1.412 1.498L3.5 14h9a1.5 1.5 0 0 0 1.498-1.412L14 12.5V6.65h1v5.85a2.5 2.5 0 0 1-2.392 2.498L12.5 15h-9a2.5 2.5 0 0 1-2.498-2.392L1 12.5v-9a2.5 2.5 0 0 1 2.392-2.498L3.5 1h5.886zm5.26.147l.707.706-8.5 8.5-.707-.707 8.5-8.5z' fill='%23767676' fill-rule='nonzero'/%3E%3C/svg%3E")
        no-repeat center;
      background-size: cover;
    }
    .social-channels .hd:before {
      display: inline-block;
      vertical-align: middle;
      content: '';
      width: 26px;
      height: 26px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: auto 100%;
    }
    .social-channels .youtube-mod .hd:before {
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAb1BMVEUAAADCDg7CDg7CDw/CDg7CDw/KEBDCDw/FDw/DDg7CDw/DDw/DDw+8AADCDg7CDg7DDw/EEBDDDw/ADg7CAADCDw/DDg7DDg7DDw/DDg7DDg7CDg7DDAzDDg7CDw/DDg7CDg7DDw/IDw/BDw/CDw9y3UGqAAAAJHRSTlMA+hvj7JkPzSpC24JQBoxYqJOHIwvffG90NrDHFNO+tqFmIGOXVR+6AAACB0lEQVRYw7WYa5ejMAiGIdFqjPdWa+11Ovz/37g7Zy9diBprdp5v9ZwigZcAwiyqsnXSRYhRl9S2UvAmJs5IkMUGVqNaTZPodp0v+xhpFoz34ONQIi2C5QEWyTV50TnMUzS0iqaYDWNCK0lmwppqWo1OYYJTRG8QnSZ84Bb8Nhw/lKY30UrkIqG3SXheGtpAwxRFm8j/UbWmTeiX1kvaSPm3NpE2gn/qNqbNxL8lgdzy9TbWj7hsbT8Mxy+Goe9t2cSP8X6OhBu/xNFyuxfPdcCNtPAFS0cNPgxPivtoD17u7A9GBvMMfionoOy278HPjvcGAMUeVLz4njAFD6gSbp34+/AIEyTirZablC6fU3AY2V8s1Ox34Zwae/bMVXPNvYqmAncV16RwPIFOCkWacBtYz0x0PLzZTPoy1tSPxD1nNXadVcAALz54pQGu8QJtsWAi8sdCZlYepPNmBAdgyHAKqU2YuDnF24qk1svqjD7A4SGkZZdqhEYFLjch8MppLi8OOUzR8TITxT6AnwL52cWVM4Ifw68cWXe4Aw+yUGPHaAM+Un4O4zQB6n0WMnL13MpZuz9+Vrk5pelTXXY/uVzUM02NyT8He0ditKwhbgFVeFv+L8NB+IgSPiiFj2vhQ2P46Bo+QIeP8eHLRPhKE75Yha93wUtm+KobvHAHr/3f9PEh/BPIDz0RW9UcvZh6AAAAAElFTkSuQmCC');
    }
    .social-channels .linkin-mod .hd:before {
      background-image: url('data:image/png;base64,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');
    }
    .social-channels .facebook-mod .hd:before {
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAARVBMVEUAAAAadvQbdvMbdvMadvMYd/YcdvIadvIbdvMadfMbdvIbdfIbd/Mcd/MadfUTd/Abd/Qacvwac/IadvYadvEadvMbdvLaj42RAAAAFnRSTlMAbdPnnR+v3u5YqYuAkkYQLggoPDe8sZg14gAAAZ5JREFUWMO1mOtygyAQhTdcRBBNNPG8/6O2Yyalpiygm37/MnG+gSOXXYnF+hiU64HeqRC9pYNMxuENZyZqxg4aWfTQNpbFoIBZqoLriArjtWzwGlW0J57ZoAkzszEqNKKYWG8azehbznDvcYD+nhkDY2Adf8ZhdeHptQvjaNZ9VPotj5lPsktD3j+k9u/FsLlNRIwCZreiWIMlXgH/a1WzQTyopNBprbP7YqCiAuPP3gTHtaLAUstyTVO9P75xALKJWnDEl2EAh638f3mtfaCclq4qBrDo7aRFVRHAM6UwS4oOiVygTqZwRBYyBSx5qcJTzOZ82XidKtPzZ0SOmE9bUY4HcgRS7QqP/LOuXRGZV9K3Kfjt2BPaFSuyNCv4RXhgIjOYiTjIthkcKenqVBSkikBRqoif2GbyzS4/cj5z8E0yxXbza4lCN15FXe0qshKFpQ1zXmFScXBWsaQS5aRi5AolXsEXSuTPKTxzsrYrDFO6tivU3FBAh8uTrF9beRkvbybkLY28sZK3d+ImU97qihtucdv/Tx8f5J9AvgDyd/b48PVgOAAAAABJRU5ErkJggg==');
    }

    .social-channels .tiktok-mod .hd:before {
      background-image: url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.985 0C5.81 0 0 5.81 0 12.985 0 20.161 5.81 25.97 12.985 25.97c7.176 0 12.985-5.809 12.985-12.985C25.985 5.81 20.161 0 12.985 0z' fill='%231F0A1C' fill-rule='nonzero'/%3E%3Cpath d='M15.912 11.013v4.67c0 2.386-1.828 4.317-4.084 4.317-2.255 0-4.083-1.931-4.083-4.316s1.828-4.317 4.083-4.317c.226 0 .463.088.677.125v2.474c-.205-.081-.44-.19-.66-.19-1.006 0-1.822.862-1.822 1.926 0 1.063.816 1.926 1.823 1.926 1.005 0 1.821-.863 1.821-1.926V6.425h2.278c0 1.783 1.368 3.228 3.055 3.228v2.39l-.016.002a5.096 5.096 0 0 1-3.072-1.032z' fill='%23FF0050'/%3E%3Cpath d='M15.167 10.588v4.67c0 2.385-1.828 4.317-4.083 4.317C8.828 19.575 7 17.643 7 15.258c0-2.384 1.828-4.316 4.084-4.316.225 0 .82.1 1.034.138v2.473c-.205-.08-.798-.202-1.017-.202-1.007 0-1.823.862-1.823 1.926 0 1.063.816 1.926 1.823 1.926 1.005 0 1.821-.863 1.821-1.926V6H15.2c0 1.783 1.368 3.228 3.055 3.228v2.39l-.016.002a5.096 5.096 0 0 1-3.072-1.032z' fill='%230FF'/%3E%3Cpath d='M18.619 11.973a5.096 5.096 0 0 1-3.072-1.031v4.67c0 2.385-1.828 4.317-4.084 4.317-2.255 0-4.084-1.932-4.084-4.317 0-2.385 1.829-4.316 4.084-4.316.226 0 .445.02.658.057v2.474a1.742 1.742 0 0 0-.64-.122c-1.007 0-1.824.861-1.824 1.926 0 1.063.817 1.926 1.823 1.926 1.005 0 1.822-.863 1.822-1.926V6.354h2.278c0 1.783 1.368 3.228 3.055 3.228v2.39l-.016.001' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E");
    }
    .social-channels .linkedin-mod .hd:before {
      background-image: url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h26v26H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zm6.118 18.124h-2.506V13.66c0-1.04-.362-1.746-1.275-1.746-.58.014-1.089.389-1.274.938a1.783 1.783 0 0 0-.084.625v4.644H11.47v-5.486c0-1.004-.034-1.845-.067-2.569h2.175l.114 1.12h.049a2.903 2.903 0 0 1 2.488-1.3c1.649 0 2.888 1.103 2.888 3.473v4.765zM8.738 6.577a1.237 1.237 0 0 1 1.318 1.251c0 .69-.51 1.252-1.349 1.252a1.254 1.254 0 1 1 .031-2.503zM7.471 18.124h2.503v-8.055H7.471v8.055z' fill='%230A66C2' mask='url(%23b)'/%3E%3C/g%3E%3C/svg%3E");
    }
    .social-channels .twitter-mod .hd:before {
      background-image: url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13zm8-17.456a6.573 6.573 0 0 1-1.888.508 3.271 3.271 0 0 0 1.442-1.808c-.629.375-1.34.65-2.08.793A3.27 3.27 0 0 0 16.076 7a3.278 3.278 0 0 0-3.278 3.28c0 .255.03.509.08.753A9.318 9.318 0 0 1 6.12 7.6a3.257 3.257 0 0 0-.446 1.656c0 1.138.579 2.142 1.461 2.732a3.306 3.306 0 0 1-1.482-.417v.04a3.28 3.28 0 0 0 2.628 3.22c-.275.07-.569.111-.863.111-.213 0-.415-.02-.62-.05a3.285 3.285 0 0 0 3.066 2.275 6.571 6.571 0 0 1-4.07 1.402c-.276 0-.53-.01-.793-.04A9.285 9.285 0 0 0 10.036 20c6.03 0 9.33-4.996 9.33-9.333 0-.142 0-.284-.01-.427A7.063 7.063 0 0 0 21 8.544' fill='%231D9BF0' fill-rule='evenodd'/%3E%3C/svg%3E");
    }
    .social-channels .bd {
      padding: 26px 14px 60px;
    }
    .social-channels .bd .txt {
      margin: 0 0 40px 0;
    }
    .channel {
      margin-bottom: 60px;
    }
    .channel .selected {
      display: block;
      cursor: pointer;
      height: 50px;
      background-color: #fff;
      position: relative;
    }
    .channel .selected input {
      width: 100%;
      background-color: transparent;
      display: block;
      height: 100%;
      text-indent: 40px;
      font-size: 16px;
      font-weight: 700;
    }
    .channel .selected span {
      margin-left: 50px;
      line-height: 50px;
      font-weight: 700;
    }
    .channel .selected .tri-ico {
      transition: all 0.2s;
      cursor: pointer;
      position: absolute;
      right: 35px;
      top: 50%;
      transform: translateY(-50%);
      display: block;
      width: 16px;
      height: 9px;
      content: '';
      background: url("data:image/svg+xml,%3Csvg width='16' height='9' viewBox='0 0 16 9' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cfilter color-interpolation-filters='auto' id='a'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 0.462325 0 0 0 0 0.462325 0 0 0 0 0.462325 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cpath d='M0 7.459L7.49 0a1.418 1.418 0 0 1 0 2.01L1.01 8.463 0 7.46zm1.016-1.01l6.569 6.538A1.42 1.42 0 0 1 7.584 15L.009 7.452l1.008-1.005-.001.002z' fill='%23515151' fill-rule='nonzero' transform='rotate(-90 4.5 4)' filter='url(%23a)'/%3E%3C/svg%3E")
        no-repeat center;
      background-size: cover;
    }
    .channel .select-list ul {
      height: auto;
      width: 100%;
    }
    .tips {
      color: #aaa;
      font-size: 14px;
      text-align: center;
    }
    .pop-wrap {
      width: 730px;
      height: 454px;
      background-color: #fff;
      text-align: center;
      overflow: hidden;
      transform: translate(-50%, -50%);
    }
    .pop-wrap .close {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      display: block;
      content: '';
      width: 25px;
      height: 25px;
      background: url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 22.167c-.35 0-.583-.117-.817-.35a1.128 1.128 0 0 1 0-1.634l14-14a1.128 1.128 0 0 1 1.634 0 1.128 1.128 0 0 1 0 1.634l-14 14c-.234.233-.467.35-.817.35zm14 0c-.35 0-.583-.117-.817-.35l-14-14a1.128 1.128 0 0 1 0-1.634 1.128 1.128 0 0 1 1.634 0l14 14a1.128 1.128 0 0 1 0 1.634c-.234.233-.467.35-.817.35z' fill='%23777' fill-rule='nonzero'/%3E%3C/svg%3E")
        no-repeat center;
      background-size: cover;
    }
    .pop-wrap:before {
      display: block;
      content: '';
      width: 120px;
      height: 120px;
      margin: 100px auto 32px;
      background: url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h120v120H0z'/%3E%3Cg transform='translate(10 17)'%3E%3Crect fill='%23F0F0F0' x='29.372' y='15' width='62' height='72' rx='11.854'/%3E%3Cpath d='M44.749 50.11a8.993 8.993 0 0 1 2.205 12.507L31.501 84.685a8.993 8.993 0 0 1-12.507 2.206 8.993 8.993 0 0 1-2.205-12.508l15.453-22.068a8.993 8.993 0 0 1 12.507-2.206z' fill='%23FFC500' fill-rule='nonzero'/%3E%3Cpath d='M75.587-1.5c7.257 0 13.12 6.138 13.281 13.73l.004.322v51.663a1.5 1.5 0 0 1-1.356 1.494l-.144.006H75.176c-5.567 0-10.135 4.77-10.281 10.758l-.004.295V86a1.5 1.5 0 0 1-1.355 1.493l-.145.007H44.626a1.5 1.5 0 0 1-.144-2.993l.144-.007h17.265v-7.732c0-7.633 5.763-13.877 12.979-14.049l.306-.004H85.87V12.552c0-6.025-4.478-10.893-10.011-11.048l-.273-.004h-48.43c-5.568 0-10.136 4.77-10.282 10.757l-.003.295v35.124a1.5 1.5 0 0 1-2.994.144l-.006-.144V12.552c0-7.633 5.762-13.876 12.978-14.048l.306-.004h48.431z' fill='%23333' fill-rule='nonzero'/%3E%3Cpath d='M78.372 15a1.5 1.5 0 0 1 .144 2.993l-.144.007h-34a1.5 1.5 0 0 1-.145-2.993l.145-.007h34zM75.372 32a1.5 1.5 0 0 1 .144 2.993l-.144.007h-20a1.5 1.5 0 0 1-.145-2.993l.145-.007h20zM76.372 48a1.5 1.5 0 0 1 .144 2.993l-.144.007h-11a1.5 1.5 0 0 1-.145-2.993l.145-.007h11zM32.372 15a1.5 1.5 0 0 1 .144 2.993l-.144.007h-7a1.5 1.5 0 0 1-.145-2.993l.145-.007h7zM86.363 63.105a1.5 1.5 0 0 1 2.125 2.112l-.108.109L64.4 87.11A1.5 1.5 0 0 1 62.274 85l.109-.11 23.98-21.784z' fill='%23333' fill-rule='nonzero'/%3E%3Cg fill='%23333' fill-rule='nonzero'%3E%3Cpath d='M15.372 74.543c-.654.934-.411 2.242.541 2.91.911.637 2.14.46 2.818-.374l.09-.118 2.457 1.721c-1.608 2.296-4.78 2.842-7.086 1.228-2.246-1.573-2.847-4.621-1.389-6.9l.12-.178 2.449 1.711zM31.674 51.236c1.785-2.55 5.323-3.158 7.904-1.35 2.52 1.765 3.188 5.176 1.555 7.71l-.12.179 2.457 1.72c2.738-3.91 1.762-9.312-2.172-12.067-3.862-2.704-9.147-1.856-11.93 1.877l-.152.21 2.458 1.72z'/%3E%3Cpath d='M25.776 47.106c4.046-5.779 12.058-7.157 17.897-3.069 5.753 4.03 7.24 11.857 3.41 17.615l-.173.252 2.458 1.721c5-7.14 3.216-17.01-3.975-22.045-7.104-4.974-16.837-3.375-21.892 3.55l-.182.255 2.457 1.721zM9.482 70.423c-2.916 4.164-1.874 9.93 2.336 12.878 4.136 2.895 9.783 1.988 12.744-1.994l.156-.216 2.458 1.72c-3.87 5.527-11.516 6.842-17.079 2.947-5.478-3.836-6.899-11.3-3.245-16.804l.173-.252 2.457 1.72z'/%3E%3Cpath d='M25.542 44.864a1.5 1.5 0 0 1 .445 1.967l-.077.122L9.53 70.346a1.5 1.5 0 0 1-2.535-1.598l.078-.123 16.38-23.393a1.5 1.5 0 0 1 2.089-.368zM31.44 48.994a1.5 1.5 0 0 1 .445 1.967l-.077.122-16.38 23.393a1.5 1.5 0 0 1-2.535-1.599l.078-.122 16.38-23.393a1.5 1.5 0 0 1 2.089-.368zM37.337 53.124a1.5 1.5 0 0 1 .446 1.966l-.077.123-16.38 23.393a1.5 1.5 0 0 1-2.535-1.599l.077-.122 16.38-23.393a1.5 1.5 0 0 1 2.09-.368zM43.235 57.253a1.5 1.5 0 0 1 .446 1.967l-.077.122-16.38 23.393a1.5 1.5 0 0 1-2.535-1.598l.077-.122 16.38-23.393a1.5 1.5 0 0 1 2.09-.369zM49.133 61.383a1.5 1.5 0 0 1 .446 1.967l-.077.122-16.38 23.393a1.5 1.5 0 0 1-2.535-1.598l.077-.123 16.38-23.393a1.5 1.5 0 0 1 2.09-.368z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
        no-repeat center;
      background-size: cover;
    }
    .pop-in {
      width: 90%;
      margin: 0 auto;
      color: #333;
    }
    .how-to-apply .join-btn,
    .join-btn {
      display: block;
      position: relative;
      margin: 0.6rem auto 0;
      width: 2.08rem;
      height: 0.52rem;
      line-height: 0.5rem;
      text-align: left;
      text-indent: 0.32rem;
      border-radius: 0.3rem;
      border: 1px solid #ffffff;
      font-size: 0.26rem;
    }
    .submint-btn {
      margin-top: 50px;
      border-color: #333;
      color: #333;
    }
    .submint-btn:hover {
      background-color: rgba(0, 0, 0, 0.05);
      color: #333;
    }
    .join-btn:after {
      width: 0.25rem;
      height: 0.25rem;
      right: 0.4rem;
      position: absolute;
      content: '';
      top: 50%;
      transform: translateY(-50%);
    }
    .submint-btn:after {
      background: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h15.237v16.235H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(0 .9)'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M15.01 11.512a.45.45 0 0 0-.614.168 7.236 7.236 0 0 1-6.279 3.655A7.225 7.225 0 0 1 .9 8.118C.9 4.138 4.137.9 8.117.9a7.166 7.166 0 0 1 6.195 3.51.45.45 0 0 0 .771-.462A8.165 8.165 0 0 0 8.117 0C3.641 0 0 3.641 0 8.118c0 4.476 3.641 8.117 8.117 8.117a8.139 8.139 0 0 0 7.06-4.11.45.45 0 0 0-.168-.613' fill='%23333' mask='url(%23b)'/%3E%3C/g%3E%3Cpath d='M16.071 7.323a.416.416 0 0 0-.71.294v1.086H9.45a.45.45 0 1 0 0 .9h5.911v1.085c0 .37.447.555.71.294l1.536-1.536a.416.416 0 0 0 0-.588L16.07 7.323z' fill='%23333'/%3E%3C/g%3E%3C/svg%3E")
        no-repeat center;
      background-size: 100% auto;
    }
  }
  :deep(.ivu-slider-button-wrap) {
    top: -9px;
  }
  // form
  .information-form {
    .from-line {
      position: relative;
      &::before {
        display: block;
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 0.35rem;
        width: 1px;
        background-color: #bfbfbf;
      }
    }
    :deep(.ivu-form-item-content) {
      line-height: 0.5rem;
    }
    :deep(.ivu-input-group .ivu-input) {
      height: 0.5rem;
      line-height: 0.5rem;
      border-color: transparent;
    }
    :deep(.ivu-input-group-prepend) {
      box-sizing: border-box;
      background-color: #fff;
      width: 20%;
      padding: 0 0 0 0.3rem;
      text-align: left;
      font-size: 18px;
      font-weight: 700;
      border-color: transparent;
    }
    :deep(.ivu-input:focus) {
      border-color: transparent;
      box-shadow: none;
    }
    :deep(.ivu-select-arrow) {
      color: #808695;
    }
    // :deep(.ivu-form-item-error .ivu-input:focus)
  }

  // 下拉选择框
  :deep(.ivu-select-selection) {
    border: 1px solid transparent;
  }
  :deep(.ivu-select-single .ivu-select-selection .ivu-select-placeholder) {
    height: 0.5rem;
    line-height: 0.5rem;
  }
  :deep(.ivu-select-selection-focused) {
    border-color: #fff;
  }
  :deep(.ivu-select-selection:hover) {
    border-color: #fff;
  }
  :deep(.ivu-select-item) {
    &:hover {
      color: #ffc550;
      background-color: transparent;
    }
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    height: 0.5rem;
    line-height: 0.5rem;
    margin: 0 25px;
    padding: 0 10px;
  }
  :deep(.ivu-select-item-selected) {
    color: #ffc550;
    background-color: transparent;
  }
  :deep(.ivu-select-dropdown) {
    max-height: 300px;
  }
  :deep(.ivu-select-single .ivu-select-selection) {
    height: 0.5rem;
    line-height: 0.5rem;
  }
  :deep(.ivu-select-single .ivu-select-selection .ivu-select-placeholder) {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  :deep(.ivu-select-single .ivu-select-selection .ivu-select-selected-value) {
    height: 0.5rem;
    line-height: 0.5rem;
  }
  :deep(.ivu-select-visible .ivu-select-selection) {
    box-shadow: none;
  }
  // 弹窗居中显示
  :deep(.vertical-center-modal) {
    display: flex;
    align-items: center;
    justify-content: center;

    :deep(.ivu-modal) {
      top: 0;
    }
  }
  .success-icon {
    display: block;
    width: 120px;
    height: 120px;
    margin: 100px auto 32px;
  }
  .modal-content {
    padding: 0 30px;
    color: #333;
    text-align: center;
    height: 180px;
  }
</style>
